import * as z from "zod";

export const getOrderAttributedConversations = {
  name: "getOrderAttributedConversations" as const,
  input: z.object({}),
  output: z.object({ conversationTopicIds: z.array(z.string()) }),
};
